import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, emitirTransferenciasProprietarios } from './types';

export const INITIAL_STATE: emitirTransferenciasProprietarios = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): emitirTransferenciasProprietarios {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EMITIR_TRANSFERENCIAS_PROPRIETARIOS_REQUEST: {
				break;
			}

			case Types.EMITIR_TRANSFERENCIAS_PROPRIETARIOS_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data.resultadoTransferencia;
				break;
			}

			case Types.EMITIR_TRANSFERENCIAS_PROPRIETARIOS_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EMITIR_TRANSFERENCIAS_PROPRIETARIOS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
